import { useState } from 'react';
import logoHorizontal from '../../assets/images/logo-horizontal.svg';
import watermark from '../../assets/shapes/watermark-union.svg';
import revealPassword from '../../assets/icons/reveal-password.svg';
import { PasswordCriteria } from '../../components/authentication/PasswordCriteria';

export const SetNewPassword = () => {
  const [revealPasswordBtn, setRevealPasswordBtn] = useState<boolean>(false);
  const [passwordValue, setPasswordValue] = useState<string>('');
  const [showPasswordCriteria, setShowPasswordCriteria] = useState<boolean>(false);

  return (
    <div className='login'>
      <div className='login__header'>
        <picture className='login__header__logo'>
          <img className='login__header__logo__img' src={logoHorizontal} alt='logo-horizontal' />
        </picture>
        <img className='login__header__watermark' src={watermark} alt='' />
      </div>
      <div className='login__box'>
        <h3 className='font-h3-regular'>Set your password</h3>
        <form className='form relative'>
          <div className='form__item relative'>
            <label className='font-h6-regular margin-left-1' htmlFor='email'>
              New password
            </label>
            <input
              className='form__item__input font-h5-regular'
              onChange={(e) => {
                setPasswordValue(e.target.value);
              }}
              type={revealPasswordBtn ? 'text' : 'password'}
              onClick={() => setShowPasswordCriteria(true)}
            ></input>
            <img className='form__item__img' src={revealPassword} onClick={() => setRevealPasswordBtn(!revealPasswordBtn)} alt='revPass' />
          </div>
          <div className='form__item relative'>
            <label className='font-h6-regular margin-left-1' htmlFor='email'>
              Repeat password
            </label>
            <input className='form__item__input font-h5-regular' type={revealPasswordBtn ? 'text' : 'password'}></input>
            <img className='form__item__img' src={revealPassword} onClick={() => setRevealPasswordBtn(!revealPasswordBtn)} alt='revPass' />
          </div>
          <button className='button-primary font-h5-medium text-white full-width' type='submit'>
            Save and Sign in
          </button>
          <PasswordCriteria passwordValue={passwordValue} showPasswordCriteria={showPasswordCriteria} />
        </form>
      </div>
    </div>
  );
};
